export const HEADER_EXTEND_KEYS = {
    NOT_SHOW_DEFAULT_ALERT_ERROR: 'not-show-default-alert-error'
};
